import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigninCallbackComponent } from './signin-callback.component';



@NgModule({
  declarations: [SigninCallbackComponent],
  imports: [
    CommonModule
  ]
})
export class SigninCallbackModule { }
